'use strict';
const angular = require('angular');

export class upcomingEventsComponent {

  constructor(ReservableEventService, Config, $location) {
    'ngInject';

    this.ReservableEventService = ReservableEventService;
    this.$location = $location;

    this.config = Config.getModuleConfig(Config.Modules.Reservation).getSettings();
  }

  $onInit() {
    this.ReservableEventService.getUpcoming({count: 3}, data => {
      this.data = data;
    }, err => {
      console.log('could not retrieve newest events');
    }) ;
  }
}

export default angular.module('conduuApp.nifty.upcomingEvents', [])
  .component('niftyUpcomingEvents', {
    template: require('./upcoming-events.html'),
    bindings: {
     count: '@',
     public: '<'
    },
    controller: upcomingEventsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/nifty/upcoming-events/upcoming-events.component.js